import ProductsTab from './subpages/products-tab/route'
import NotesTasksTab from './subpages/notes-tasks-tab/route'
import OrdersInvoicesTab from './subpages/orders-invoices-tab/route'
import LicensesTab from './subpages/license-tab/route'
import ContactsTab from './subpages/contacts-tab/route'
import AddressesTab from './subpages/addresses-tab/route'
import MetaDataTab from './subpages/meta-data-tab/route'

export default {
  path: '/publishers/:id',
  component: () => import(/* webpackChunkName: "publisher-show" */ './PublisherShow'),
  props: true,
  meta: {
    requiresAuth: true
  },
  redirect: '/publishers/:id/products',
  children: [ProductsTab, NotesTasksTab, OrdersInvoicesTab, LicensesTab, ContactsTab, AddressesTab, MetaDataTab]
}
